import { SpringParallax } from '@ccg/core';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React$1, { useState } from 'react';
import PropTypes$1 from 'prop-types';
import Grid$1 from '../Grid/Grid.js';
import CssIcon from '../../basics/Icon/Icon.js';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import { StyledTeamMembers, StyledTeam } from './Team.style.js';

const TeamMembers = ({
  members,
  hideMembers
}) => {
  const [isVisible, setIsVisible] = useState(!hideMembers);
  return /*#__PURE__*/React$1.createElement(StyledTeamMembers, {
    isVisible: isVisible
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "teamMembers__list"
  }, members.map(member => /*#__PURE__*/React$1.createElement("div", {
    key: member.id,
    className: "teamMembers__member"
  }, member.link ? /*#__PURE__*/React$1.createElement(Link$1, _extends({
    key: member.id,
    transform: "uppercase",
    icon: "default"
  }, member.link), member.name + (member.status === 'suspended' ? ' (Alumni)' : '')) : /*#__PURE__*/React$1.createElement(Typography$1, {
    transform: "uppercase"
  }, member.name + (member.status === 'suspended' ? ' (Alumni)' : '')), member.role && /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "small"
  }, member.role)))), hideMembers && /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    onClick: () => setIsVisible(prev => !prev)
  }, /*#__PURE__*/React$1.createElement(Typography$1, null, isVisible ? 'Hide all' : 'Show all'), /*#__PURE__*/React$1.createElement(CssIcon, {
    icon: isVisible ? 'arrowUp' : 'arrowDown'
  })));
};
TeamMembers.propTypes = {
  hideMembers: PropTypes$1.bool,
  members: PropTypes$1.arrayOf(PropTypes$1.shape({
    id: PropTypes$1.string.isRequired,
    role: PropTypes$1.string,
    name: PropTypes$1.string.isRequired,
    link: PropTypes$1.shape()
  }))
};
TeamMembers.defaultProps = {
  hideMembers: false,
  members: []
};

const Team = ({
  companies,
  primaryMembers,
  secondaryMembers
}) => /*#__PURE__*/React$1.createElement(StyledTeam, null, /*#__PURE__*/React$1.createElement(SpringParallax, null, /*#__PURE__*/React$1.createElement(Grid$1, null, primaryMembers.length > 0 && /*#__PURE__*/React$1.createElement(TeamMembers, {
  members: primaryMembers
}), secondaryMembers.length > 0 && /*#__PURE__*/React$1.createElement(TeamMembers, {
  members: secondaryMembers,
  hideMembers: true
})), /*#__PURE__*/React$1.createElement("div", {
  className: "team__companies"
}, companies.map(item => /*#__PURE__*/React$1.createElement("div", {
  className: "team__company",
  key: item.id
}, /*#__PURE__*/React$1.createElement(Link$1, {
  href: item.website,
  target: "_blank",
  rel: "noopener noreferrer",
  icon: "default",
  component: "a",
  transform: "uppercase"
}, item.title))), /*#__PURE__*/React$1.createElement(Typography$1, {
  as: "span",
  variant: "small"
}, "Beteiligte Agenturen"))));

Team.propTypes = {
  companies: PropTypes$1.arrayOf(PropTypes$1.shape({
    id: PropTypes$1.string.isRequired,
    title: PropTypes$1.string.isRequired,
    website: PropTypes$1.string.isRequired
  })).isRequired,
  primaryMembers: PropTypes$1.arrayOf(PropTypes$1.shape()),
  secondaryMembers: PropTypes$1.arrayOf(PropTypes$1.shape())
};
Team.defaultProps = {
  primaryMembers: [],
  secondaryMembers: []
};

export default Team;
export { TeamMembers };
